type ValidationResult = string | null;

export const checkUsername = (username: string): ValidationResult => {
    if (!username || username.length < 1 || username.length > 15) {
        return "이름/닉네임은 1~15자 이내로 입력해주세요.";
    }
    return null;
};

export const checkEmail = (email: string): ValidationResult => {
    if (!email || !email.includes('@') || !email.includes('.')) {
        return "올바른 이메일 주소를 입력해주세요.";
    }
    return null;
};

export const checkPassword = (password: string): ValidationResult => {
    const isValid = password.length >= 8 &&
        /\d/.test(password) &&
        /[a-zA-Z]/.test(password) &&
        /[^a-zA-Z0-9]/.test(password);

    if (!isValid) {
        return "* 영어, 숫자, 특수문자를 조합하여 8~12자 이내로 설정해주세요.";
    }
    return null;
};

export const checkRepeatPassword = (password: string, repeatPassword: string): ValidationResult => {
    if (password !== repeatPassword) {
        return "비밀번호가 일치하지 않습니다.";
    }
    return null;
}; 